/**
 * OVERRIDE Data.jsx
 * REASON: Add Refresh source content button.
 * FILE: https://github.com/kitconcept/volto-slider-block/blob/74cb8f01394907ff7b765c74c4a43ceb793c1c95/packages/volto-slider-block/src/components/Data.jsx
 * DATE: 2025-09-11
 * DEVELOPER: @Tishasoumya-02
 */

import Data from '../../../../components/Blocks/Slider/Data';

export default Data;
